import React from 'react'
import { Modal, Typography, Card, CardActions, CardHeader } from '@mui/material'
import { IconBtn, InputButton } from '../../Simple'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'

export default function RegraCancelamento({ emp, actionsCtxEmps, open, onClose, width }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Card
        sx={{
          width: width,
          bgcolor: 'background.paper',

          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          borderRadius: 3,
          padding: 2,
        }}
      >
        <CardHeader
          sx={{ padding: 0, pb: 1 }}
          title={
            <Typography variant='body1' fontWeight='bold' align='left'>
              Regra de Cancelamento
            </Typography>
          }
          action={<IconBtn onClick={onClose} Icon={CloseIcon} className='tw-text-orange-500' />}
        />
        <Box>
          {emp.regrasCancelamento ? (
            actionsCtxEmps.ShowRegraCancelamento(emp.regrasCancelamento[0])
          ) : (
            <Typography variant='body1'>Não há regras de cancelamento cadastradas</Typography>
          )}
        </Box>
        <CardActions disableSpacing>
          <InputButton
            variant='text'
            onClick={onClose}
            fullWidth
            sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0 }}
          >
            <Typography variant='body1' fontWeight='bold' color='primary'>
              Entendi
            </Typography>
          </InputButton>
        </CardActions>
      </Card>
    </Modal>
  )
}
